const drawOnMapConstants = {
    "drawOnMapPath": "/geofence",
    drawOnMapTitle: "Geofence",
    geofence: "Geofence",
    instructions: "Geofence",
}

export default drawOnMapConstants